import { deserialize, deserializeAs } from "cerialize";


export class EquipementMetadata {

  @deserialize
  reference;

  @deserializeAs('url_fabriquant')
  urlFabriquant;

  @deserialize
  notice;

  @deserialize
  image;

}
